import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Apps from "./pages/apps/Apps";
import RealEstateAssist from "./pages/apps/RealEstateAssist";
import RealEstateAssistPrivacy from "./pages/apps/RealEstateAssistPrivacy";
import RealEstateAssistSupport from "./pages/apps/RealEstateAssistSupport";
import RealEstateAssistHowTo from "./pages/apps/RealEstateAssistHowTo";

// Navbar
import AppNavBar from "./components/AppNavBar";

// Footer
import Footer from "./components/Footer";

const pageTitles = {
  "/": "Cross Vision Development Studios | Custom Software Development",
  "/about": "About | Cross Vision Development Studios",
  "/services": "Services | Cross Vision Development Studios",
  "/portfolio": "Portfolio | Cross Vision Development Studios",
  "/contact": "Contact | Cross Vision Development Studios",
  "/apps": "Our Apps | Cross Vision Development Studios",
  "/apps/real-estate-assist":
    "Real Estate Agent Assist | Cross Vision Development Studios",
  "/apps/real-estate-assist/privacy":
    "Real Estate Agent Assist Privacy Policy | Cross Vision Development Studios",
  "/apps/real-estate-assist/support":
    "Real Estate Agent Assist Support | Cross Vision Development Studios",
  "/apps/real-estate-assist/how-to":
    "How-To Videos: Real Estate Agent Assist | Cross Vision Development Studios",
};

// Scroll to top and set the document title on every route change
const RouteEffects = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      pageTitles[pathname] || "Cross Vision Development Studios";
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteEffects />
        <AppNavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/apps/real-estate-assist" element={<RealEstateAssist />} />
          <Route
            path="/apps/real-estate-assist/privacy"
            element={<RealEstateAssistPrivacy />}
          />
          <Route
            path="/apps/real-estate-assist/support"
            element={<RealEstateAssistSupport />}
          />
          <Route
            path="/apps/real-estate-assist/how-to"
            element={<RealEstateAssistHowTo />}
          />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
